const companyChangeTerm = `
    <table align="center" cellpadding="0" cellspacing="0" width="600"  style="border-collapse: collapse;">
        <tr>
            <td>
                <img height="70" src="http://fcstoragebr.blob.core.windows.net/images/Fcamara/Logotipo-Horizontal-FCamara-2015.png">
            </td>
        </tr>
        <tr>
            <td align="center" height='100px'>
                <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>TERMO ADITIVO CONTRATUAL - "AC"</strong></p>
            </td>
        </tr>
        <tr>
            <td>
            <div class="main">

                <p>
                    O presente instrumento particular complementa e detalha o Contrato de Prestação de Serviços em Informática assinado em {{contractstart}} firmado entre as partes a seguir qualificadas.
                </p>

                <p>
                    De um lado, <strong>NAÇÃO DIGITAL SOLUTIONS S.A.</strong>, regularmente inscrita no CNPJ/MF sob o nº 15.341.754/0001-82, e tem a sua sede na Cidade de Maringá, Estado do Paraná, na Av. João Paulino Vieira Filho, nº 672, Edifício New Center Empresarial, sala 101, Zona 01, CEP 87020-015, designada <strong>“CONTRATANTE”</strong>. E, de outro lado {{companyname}}, regularmente inscrita no CNPJ/MF sob o nº {{companycnpj}}, com sede na {{companyaddress}}, nº {{companynumber}}, CEP. {{companycep}}, {{companycity}}/{{companystate}}, designada <strong>“CONTRATADA”</strong>.
                </p>

                <p style="border: solid 1px #000;">
                    <strong>1. DO OBJETO DO CONTRATO </strong><br>
                    1.1. O presente termo aditivo tem por objeto a alteração da razão social da <strong>CONTRATADA</strong>.
                </p>

                <p style="border: solid 1px #000;">
                    <strong>2. DA ALTERAÇÃO </strong><br>
                    2.1. A CONTRATADA passou a denominar-se {{oldcompanyname}}, registrada sob o CNPJ nº {{oldcompanycnpj}}, com sede na {{oldcompanyaddress}}, nº {{oldcompanynumber}}, CEP. {{oldcompanycep}}, {{oldcompanycity}}/{{oldcompanystate}}.
                </p>

                <p>
                    E por estarem assim justas e contratadas, assinam as partes o presente instrumento, em duas vias de igual teor e forma, perante a presença de seus representantes legais e duas testemunhas presenciais.
                </p>

                <br>
                </td>
                </tr>
                <tr>
                <td align="center" height='60px'>

                <p style="text-align: center; margin-top: 50px;">
                    <strong>Maringá</strong>, {{datecontract}}
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        <strong>NAÇÃO DIGITAL SOLUTIONS S.A
                        CONTRATANTE</strong>
                    </span>
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        {{oldcompanyname}}<br>
                    </span>
                </p>

                <p style="text-align: center; margin-top: 80px;">
                    <span>
                        ___________________________________________________<br>
                        {{companyname}}<br>
                    </span>
                </p>

                <!-- TESTEMUNHASSSS -->
                <p style="margin-top: 50px;">
                    <strong>TESTEMUNHAS</strong>
                </p>
                <div class="testemunhas" style="margin: 0; text-align: left;">
                    <table style="width: 100%;">
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td style="width: 50%;">
                                    <span>
                                        1. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                                <td style="width: 50%;">
                                    <span>
                                        2. __________________________<br>
                                        Nome:<br>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </td>
        </tr>
    </table>
`;

export default companyChangeTerm;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/clicksignDocumentTemplates/companyChangeTerm.ts